import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import config from '../config/seo.json';
import seoHelpers from '../config/seo';

const { getPageSeo } = seoHelpers;

// Automatic page views are disabled in index.html; track React navigation once.
const Analytics = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const production = window.location.hostname === new URL(config.siteUrl).hostname;
    if (!production || !window.gtag || pathname.startsWith('/admin')) return;
    const pageLocation = `${config.siteUrl}${pathname}${search}`;
    if (window.__academyLastPageView === pageLocation) return;
    window.__academyLastPageView = pageLocation;
    window.gtag('event', 'page_view', {
      page_location: pageLocation,
      page_title: getPageSeo(pathname).title,
      send_to: config.analyticsId,
    });
  }, [pathname, search]);

  return null;
};

export default Analytics;
